export interface TimeLog {
  id?: string;
  user_id?: string;
  log_date: string;
  check_in?: string;
  check_out?: string;
  hours?: number;
  status?: string;
}

export interface ActiveBreak {
  id: string;
  break_type: string;
  started_at: string;
}

export interface TodayResponse {
  log: TimeLog | null;
  activeBreak: ActiveBreak | null;
}

export interface TeamMember {
  id: string;
  display_name: string;
  department?: string;
  check_in?: string;
  check_out?: string;
  hours?: number;
}

export type BreakType = 'lunch' | 'tea' | 'bio' | 'meeting';

export const BREAK_OPTIONS: { value: BreakType; label: string }[] = [
  { value: 'lunch', label: 'Lunch' },
  { value: 'tea', label: 'Tea' },
  { value: 'bio', label: 'Restroom' },
  { value: 'meeting', label: 'Meeting' },
];
